module.exports = __webpack_public_path__ + "src/assets/img/trank_open_color.e6d832ca.svg";